export default __webpack_public_path__ + "static/media/img-0812-czech-republic-full-face.02ee924c.png";